<template>
  <vx-card>
    <vs-row v-if="!categories">
      <vs-col id="categories-loading" class="vs-con-loading__container" style="min-height: 100px;">

      </vs-col>
    </vs-row>
    <vs-row v-else>
      <vs-col :class="index>0 ? 'mt-10':''" v-for="(category, index) in categories.$getEmbedded('document-categories')" :key="index">
        <vs-row>
          <vs-col>
            <div class="vx-card__title mb-6"><h4 class="">{{ category.name }}</h4></div>
          </vs-col>
        </vs-row>
        <vs-row vs-justify="center" vs-align="center">
          <vs-col vs-w="12" class="my-2" v-for="(document,index2) in category.$getEmbedded('documents')" :key="index2">
            <a @click="download(document)" style="cursor: pointer;font-size:1.2rem;">{{ document.name }} ({{ document.type }})</a>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import {ResourceImpl} from 'hal-client';
import {saveAs} from 'file-saver';

export default {
  name: 'dashboard-resources-card',
  props: {
    dashboardResource: ResourceImpl
  },
  data () {
    return {
      categories: null,
      loading: new Set()
    };
  },
  watch: {
    categories (value) {
      if (value) {
        this.$vs.loading.close('#categories-loading > .con-vs-loading');
      }
    }
  },
  mounted () {
    this.$vs.loading({
      container: '#categories-loading',
      scale: 0.6
    });

    if (this.dashboardResource.$hasLink('document-categories')) {
      this.dashboardResource.$request().$get('document-categories').then(res => {
        this.categories = res;
      });
    }
  },
  methods: {
    download (document) {
      this.$http.get(document.$href('download'), {responseType: 'blob'}).then(res => {
        saveAs(res.data, document.filename.replaceAll(' ', '_'));
      });
    }
  }
};
</script>

<style scoped>

</style>
